var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSideIconServerConfig = function SvgSideIconServerConfig(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 3h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm1 2v7h14V5H4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16h4v2H9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 18h8a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 7a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm0 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6h1v1h-1zm0 5h1v1h-1zm-2.1-.9l.7.7-.7.7-.7-.7zm4.1 0l.7.7-.7.7-.7-.7zM8.4 7.5l.7.7-.7.7-.7-.7zm4.1 0l.7.7-.7.7-.7-.7zM8 8.5h1v1H8zm4 0h1v1h-1z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSideIconServerConfig);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/side-icon-ServerConfig.e9e9eddca7dfc0cf833d26813e098959.svg";